import { saveAs as importedSaveAs } from "file-saver";

import {
  created_by,
  otherAPIHeaders,
  testAPIHeaders,
  uploadAPIHeaders,
} from "../shared-resources/dumpData";

export function getRolesAPI() {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(
        `${process.env.KIRKLAND_APP_API_URL}/user-setting/userRoles`,
        {
          method: "GET",
          headers: testAPIHeaders,
        }
      );

      if (!response.ok) {
        throw new Error(response.statusText);
      }
      const res = await response.json();
      resolve(res.data);
    } catch (err) {
      reject(err);
    }
  });
}
